import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getIsabelState = (state: RootState) => state.isabel;

export const selectIsabelDiagnoses = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.diagnoses
);

export const selectLoadingIsabelDiagnoses = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.loadingDiagnoses
);

export const selectIsabelCountries = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.countries
);

export const selectIsabelCurrentJourney = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.isabelCurrentJourney
);

export const selectTriageScore = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.triageScore
);

export const selectLoadingTriageScore = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.loadingTriageScore
);

export const selectKnowledgeUrls = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.knowledgeUrls
);

export const selectLoadingKnowledgeUrls = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.loadingKnowledgeUrls
);

export const selectLoadingSaveToMyJourney = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.saveToMyJourneyLoading
);

export const selectIsabelSymptoms = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.isabelSymptoms
);

export const selectIsConditionModalOpen = createSelector(
  [getIsabelState],
  (isabelState) => isabelState.isConditionModalOpen
);
